
import { computed, ref, onMounted, nextTick } from 'vue'
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['onOk', 'onCancel'],
  setup (props, { emit }) {
    const visibleCompu = computed(() => props.visible)

    const loadingCompu = computed(() => props.loading)

    const formRef = ref()
    const formData = ref({})

    const handleCancel = () => {
      emit('onCancel')
    }
    const inputRef = ref()

    const handleOk = () => {
      formRef.value.validate().then(() => {
        emit('onOk', formData.value)
      })
    }

    onMounted(async () => {
      await nextTick()
      inputRef.value.focus()
    })

    return {
      visibleCompu,
      loadingCompu,
      formRef,
      formData,
      handleCancel,
      handleOk,
      inputRef
    }
  }
}
